var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 8.66663H9.16699V12.6666C9.16699 13.0333 8.86699 13.3333 8.50032 13.3333C8.13366 13.3333 7.83366 13.0333 7.83366 12.6666V8.66663H3.83366C3.46699 8.66663 3.16699 8.36663 3.16699 7.99996C3.16699 7.63329 3.46699 7.33329 3.83366 7.33329H7.83366V3.33329C7.83366 2.96663 8.13366 2.66663 8.50032 2.66663C8.86699 2.66663 9.16699 2.96663 9.16699 3.33329V7.33329H13.167C13.5337 7.33329 13.8337 7.63329 13.8337 7.99996C13.8337 8.36663 13.5337 8.66663 13.167 8.66663Z",
    fill: "#9F9978"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0481b832ac32a899f6e5fa4d5a678a5a.svg";
export { ForwardRef as ReactComponent };